import * as React from 'react';
import { Text, Checkbox } from '@serodigital/ui-components';

export enum Weekday {
  MONDAY = 'Mon',
  TUESDAY = 'Tue',
  WEDNESDAY = 'Wed',
  THURSDAY = 'Thurs',
  FRIDAY = 'Fri',
  SATURDAY = 'Sat',
  SUNDAY = 'Sun',
}

export enum WeekdayFull {
  Mon = 'monday',
  Tue = 'tuesday',
  Wed = 'wednesday',
  Thurs = 'thursday',
  Fri = 'friday',
  Sat = 'saturday',
  Sun = 'sunday',
}

interface IWeekdayCheckboxProps {
  weekday: Weekday;
  register: any;
  name: any;
  error: boolean;
  defaultChecked?: boolean;
}

export const WeekdayCheckbox = ({ weekday, register, error, name, defaultChecked }: IWeekdayCheckboxProps) => {
  const { onChange: onChangeHandler, ...rest } = register(name);
  return (
    <div className="flex flex-col items-center">
      <Text data-qa="weekday-checkbox-text" className="sero-text-large mb-8">
        {weekday}
      </Text>
      <Checkbox
        data-qa={`${name}-checkbox`}
        checked={defaultChecked}
        onChangeHandler={onChangeHandler}
        {...rest}
        error={error}
      />
    </div>
  );
};
